import React from 'react'
import './styles.scss'

export default () => (
  <div className='header'>
    <span>Bucket</span>
    <span>Size</span>
    <span>Cost</span>
    <span>Date</span>
  </div>
)
